import { Grid } from '@mui/material';

import { ReconciliationNomenclatureList } from './nomenclature/ReconciliationNomenclatureList';
import { ReconciliationUnboundDrugsList } from './unbound/ReconciliationUnboundDrugsList';

export const ReconciliationBindingContent = () => (
  <Grid container columnSpacing={1} sx={{ flexGrow: 1 }}>
    <Grid item xs={5}>
      <ReconciliationUnboundDrugsList />
    </Grid>

    <Grid item xs={7}>
      <ReconciliationNomenclatureList />
    </Grid>
  </Grid>
);
